import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { weekdays } from "frontend/src/features/timetable";
import { makeStyles } from "@material-ui/core/styles";
import { FormHelperText } from "@material-ui/core";
var useStyles = makeStyles(function (theme) { return ({
    toggleButton: {
        "&.Mui-selected, &.Mui-selected:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
    },
}); });
export var WeekdayList = function (_a) {
    var index = _a.index, days = _a.days, onChange = _a.onChange, noDaysSelectedError = _a.noDaysSelectedError;
    var classes = useStyles();
    var changeDays = function (event, value) {
        onChange(value, index);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ToggleButtonGroup, { color: "primary", value: days, onChange: changeDays }, weekdays.map(function (label, idx) {
            return (React.createElement(ToggleButton, { key: label, value: idx, classes: { root: classes.toggleButton } }, label));
        })),
        noDaysSelectedError && (React.createElement(FormHelperText, { error: true }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u043D\u0438 \u043D\u0435\u0434\u0435\u043B\u0438."))));
};
